export class LockModel{
    orderId:string = "";
}